import React, { useEffect, useState } from 'react'
import { useParams, useNavigate, Link } from 'react-router-dom'
import { FiArrowLeft, FiDollarSign, FiUser, FiCreditCard, FiCalendar, FiCheckCircle } from 'react-icons/fi'
import adminApi from '../../api/adminApi'
import StatusBadge from '../../components/StatusBadge/StatusBadge'
import Button from '../../components/Button/Button'
import './PaymentDetail.css'

const PaymentDetail = () => {
  const { paymentId } = useParams()
  const navigate = useNavigate()
  
  const [payment, setPayment] = useState(null)
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)

  useEffect(() => {
    loadPayment()
  }, [paymentId])

  const loadPayment = async () => {
    setLoading(true)
    setError(null)
    try {
      const response = await adminApi.get(`/payments/${paymentId}`)
      setPayment(response.data)
    } catch (err) {
      setError(err.response?.data?.message || 'Failed to load payment')
    } finally {
      setLoading(false)
    }
  }

  if (loading) {
    return <div className="detail-loading">Loading payment details...</div>
  }

  if (error && !payment) {
    return (
      <div className="detail-error">
        <p>{error}</p>
        <Button onClick={() => navigate('/payments')}>Back to Payments</Button>
      </div>
    )
  }

  return (
    <div className="payment-detail-page">
      <header className="detail-header">
        <Link to="/payments" className="back-link">
          <FiArrowLeft size={20} />
          Back to Payments
        </Link>
      </header>

      <div className="detail-content">
        <div className="detail-main">
          <section className="detail-card">
            <div className="card-header">
              <div className="payment-icon">
                <FiDollarSign size={32} />
              </div>
              <div>
                <h1>Payment Details</h1>
                <StatusBadge status={payment?.status || 'pending'} />
              </div>
            </div>

            <div className="payment-amount">
              <span className="amount-label">Amount</span>
              <strong className="amount-value">₹{payment?.amount || 0}</strong>
            </div>

            <div className="info-grid">
              <div className="info-item">
                <FiUser size={18} />
                <div>
                  <span className="info-label">Student</span>
                  <Link
                    to={`/users/${payment?.user?._id}`}
                    className="info-link"
                  >
                    <strong>
                      {payment?.user?.firstName} {payment?.user?.lastName}
                    </strong>
                  </Link>
                  <span>{payment?.user?.email}</span>
                </div>
              </div>
              <div className="info-item">
                <FiCreditCard size={18} />
                <div>
                  <span className="info-label">Payment Method</span>
                  <strong>{payment?.paymentMethod || '—'}</strong>
                </div>
              </div>
              <div className="info-item">
                <FiCalendar size={18} />
                <div>
                  <span className="info-label">Payment Date</span>
                  <strong>
                    {payment?.createdAt
                      ? new Date(payment.createdAt).toLocaleDateString()
                      : '—'}
                  </strong>
                </div>
              </div>
              {payment?.transactionId && (
                <div className="info-item">
                  <FiCheckCircle size={18} />
                  <div>
                    <span className="info-label">Transaction ID</span>
                    <strong className="transaction-id">{payment.transactionId}</strong>
                  </div>
                </div>
              )}
            </div>

            {payment?.enrollment && (
              <div className="enrollment-link">
                <Link to={`/enrollments/${payment.enrollment._id}`}>
                  View Related Enrollment →
                </Link>
              </div>
            )}
          </section>
        </div>
      </div>
    </div>
  )
}

export default PaymentDetail

